<template>
  <section class="fabric-segments">
    <div class="segments-toolbar">
      <div><strong>{{ rollNo || '本卷' }} · 人员分段</strong><span>按生产圈数排序 · 仅显示已同步数据 · 北京时间</span></div>
      <Button size="small" :loading="loading" icon="md-refresh" @click="load">刷新分段</Button>
    </div>
    <Alert v-if="error" type="error" show-icon>{{ error }}</Alert>
    <SegmentTable :key="`${context}:${page}:${pageSize}`" size="small" border :rows="segments" :total="total" :loading="loading" :no-data-text="error ? '加载失败，请点击刷新分段重试' : status === 'READY' ? '尚未开始生产，暂无分段' : '暂无已同步分段'" />
    <div class="segments-footer"><span>共 {{ total }} 段</span><Page size="small" :current="page" :total="total" :page-size="pageSize" :page-size-opts="[20, 50, 100]" show-sizer @on-change="changePage" @on-page-size-change="changePageSize" /></div>
  </section>
</template>

<script>
import { fabricSegments, productionData, productionError } from '@/api/production'
import segmentPresentation from './segment-presentation'
import SegmentTable from './segment-table.vue'

export default {
  name: 'FabricSegments',
  components: { SegmentTable },
  mixins: [segmentPresentation],
  props: {
    factoryId: { type: Number, required: true },
    fabricId: { type: String, required: true },
    rollNo: { type: String, default: '' },
    status: { type: String, default: '' }
  },
  data () { return { segments: [], total: 0, page: 1, pageSize: 20, loading: false, error: '', sequence: 0 } },
  computed: { context () { return `${this.factoryId}:${this.fabricId}` } },
  watch: { context () { this.page = 1; this.load() } },
  mounted () { this.load() },
  beforeDestroy () { this.sequence++ },
  methods: {
    changePage (page) { this.page = page; return this.load() },
    changePageSize (size) { this.pageSize = size; this.page = 1; return this.load() },
    async load () {
      const sequence = ++this.sequence
      this.segments = []; this.total = 0; this.error = ''
      if (!this.factoryId || !this.fabricId) { this.loading = false; return }
      this.loading = true
      try {
        const result = productionData(await fabricSegments(this.factoryId, this.fabricId, { page: this.page, pageSize: this.pageSize }))
        if (sequence !== this.sequence) return
        this.segments = result.items || []; this.total = Number(result.total) || 0
      } catch (error) {
        if (sequence === this.sequence) this.error = productionError(error)
      } finally { if (sequence === this.sequence) this.loading = false }
    }
  }
}
</script>

<style scoped>
.fabric-segments { padding: 4px 8px; border-left: 3px solid #2d8cf0; }
.segments-toolbar, .segments-footer { display: flex; justify-content: space-between; align-items: center; gap: 16px; }
.segments-toolbar { margin-bottom: 12px; }
.segments-toolbar span { display: block; margin-top: 4px; color: #808695; }
.segments-footer { margin-top: 12px; color: #808695; }
@media (max-width: 700px) { .segments-footer { align-items: flex-start; flex-direction: column; } }
</style>
